export default {
  placeholder: 'Cerca attività...',
};
